import { AsyncAction } from "@/Common/Api/AsyncActions/AsyncAction";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { EncounterPatientFormsResponse } from "@/Patient/Models/Forms/EncounterPatientFormsResponse";

class FormAction extends AsyncAction {
    public async getEncounterPatientForms(formName: string, encounterId: string, patientContactFacetId: string): Promise<EncounterPatientFormsResponse> {
        return this.postAsync<EncounterPatientFormsResponse>(ServerOperations.Server.Myle_Patient_MedicalNote_GetEncounterPatientFormsByName, {
            FormName: formName,
            EncounterId: encounterId,
            PatientContactFacetId: patientContactFacetId
        });
    }
}

export { FormAction };
